module.exports = __webpack_public_path__ + "img/img3.f653cdc1.png";